class KosasShadeFinder extends HTMLElement {
  connectedCallback() {
    this.steps = [...this.querySelectorAll('[data-shade-step]')];
    this.answers = {};
    this.index = 0;
    this.addEventListener('click', this.handleClick);
    this.render();
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.handleClick);
  }

  handleClick = (event) => {
    const option = event.target.closest('[data-shade-option]');
    if (option) {
      const step = this.steps[this.index];
      step.querySelectorAll('[data-shade-option]').forEach((button) => button.setAttribute('aria-pressed', 'false'));
      option.setAttribute('aria-pressed', 'true');
      this.answers[step.dataset.shadeStep] = option.dataset.shadeOption;
      this.querySelector('[data-shade-next]').disabled = false;
      return;
    }

    if (event.target.closest('[data-shade-next]')) {
      if (this.index < this.steps.length - 1) {
        this.index += 1;
        this.render();
      } else {
        this.showResult();
      }
      return;
    }

    if (event.target.closest('[data-shade-back]') && this.index > 0) {
      this.index -= 1;
      this.render();
      return;
    }

    if (event.target.closest('[data-shade-reset]')) {
      this.answers = {};
      this.index = 0;
      this.querySelectorAll('[data-shade-option]').forEach((button) => button.setAttribute('aria-pressed', 'false'));
      this.querySelector('[data-shade-result]').hidden = true;
      this.render();
    }
  };

  render() {
    this.steps.forEach((step, index) => { step.hidden = index !== this.index; });
    this.querySelector('[data-shade-result]').hidden = true;
    this.querySelector('[data-shade-controls]').hidden = false;
    this.querySelector('[data-progress-current]').textContent = String(this.index + 1);
    this.querySelector('[data-shade-back]').disabled = this.index === 0;
    this.querySelector('[data-shade-next]').disabled = !this.answers[this.steps[this.index].dataset.shadeStep];
  }

  showResult() {
    this.steps.forEach((step) => { step.hidden = true; });
    this.querySelector('[data-shade-controls]').hidden = true;
    const result = this.querySelector('[data-shade-result]');
    result.hidden = false;
    result.querySelectorAll('[data-result-product]').forEach((product) => {
      product.hidden = product.dataset.resultProduct !== this.answers.product;
    });
    const labels = {
      concealer: 'Conceal + Brighten', foundation: 'Foundation', sunscreen: 'Tinted SPF',
      natural: 'Natural Skin', radiant: 'Fresh + Radiant', 'soft-matte': 'Soft Matte'
    };
    result.querySelector('[data-result-answers]').textContent = `${labels[this.answers.product]} / ${labels[this.answers.finish]} / ${this.answers.depth}`;
    result.querySelector('[data-result-heading]').textContent = `${this.answers.depth[0].toUpperCase()}${this.answers.depth.slice(1)} complexion match`;
  }
}

if (!customElements.get('kosas-shade-finder')) {
  customElements.define('kosas-shade-finder', KosasShadeFinder);
}
